// Shared by the AI Features tab and its turn-on modal, which both link out to it.
export const TCI_AI_APPROACH_URL = 'https://www.teachtci.com/tci-ai-approach/';
